import { defineComponent } from 'vue';
import axios, { AxiosResponse } from 'axios';
import * as bootstrap from "bootstrap";
import DCApp from "./../Shared/App.vue";
import * as Vue from 'vue';
import { newsElem, NewsViewApiModel } from './newsmodule';
import { createPinia } from 'pinia';

let gactucats: string;
let gnumnews: number;
let gpage: number = 1;
let glancurrent: string = "fr";
let giscat: boolean = false;


const mixin = defineComponent({
    data() {
        return {
            iscat:false,
            newcheckdccat: false,
            newcheckmatoscat: false,
            newcheckjeuxcat: false,
            dcloadingnews: false,
            optionscat: [] as number[],
            last_page: 1,
            postnews: [] as newsElem[],
            urlphoto: "",
            urlnews: "",
            numnews: 0,
            lancurrent: "fr",
            actucats: ""
        };
    },




    created() {
        window.addEventListener('scroll', async (e: any) => {await this.handleScroll(e) }, { passive: true });
    },

    unmounted() {
        window.removeEventListener('scroll', async (e: any) => { await this.handleScroll(e) });
    },

    mounted() {
        this.iscat = giscat;
        this.last_page = gpage + 1;
        this.actucats = gactucats;
        this.lancurrent = glancurrent;
        const options = gactucats.split(",");
        this.newcheckdccat = false;
        this.newcheckmatoscat = false;
        this.newcheckjeuxcat = false;
        this.numnews = gnumnews;
        for (const option of options) {
            if (+option === 189)
                this.newcheckdccat = true;
            if (+option === 191)
                this.newcheckmatoscat = true;
            if (+option === 190)
                this.newcheckjeuxcat = true;
        }
    },
    methods: {

        GetOptions(): number[] {
            this.optionscat = [];
            if (this.newcheckdccat)
                this.optionscat.push(189);
            if (this.newcheckmatoscat)
                this.optionscat.push(191);
            if (this.newcheckjeuxcat)
                this.optionscat.push(190);
            return this.optionscat;
        },

        async Title_ToggleCatDC(event: any) {
            this.newcheckdccat = event.target.checked;
            await this.ValidateBtn();
        },

        async Title_ToggleCatMatos(event: any) {
            this.newcheckmatoscat = event.target.checked;
            await this.ValidateBtn();

        },

        async Title_ToggleCatJeux(event: any) {
            this.newcheckjeuxcat = event.target.checked;
            await this.ValidateBtn();

        },
        IsDisabledCat(up: boolean): boolean {
            let numbutactive = 0;
            if (this.newcheckdccat)
                numbutactive++;
            if (this.newcheckmatoscat)
                numbutactive++;
            if (this.newcheckjeuxcat)
                numbutactive++;
            if (up)
                return numbutactive <= 1;
            else
                return false;
        },

        SetUrlPhoto(url: string) {
            this.urlphoto = url;
        },

        SetUrlNews(url: string) {
            this.urlnews = url;
        },

        GetUrlNews(page: number): string {
            return this.urlnews.replace("-1", page.toString());
        },

        GetUrlPhoto(page: number): string {
            return this.urlphoto.replace("-1", page.toString());
        },

        async handleScroll(event: any) {
            let self = this;
            let offset = $('.mc_piedpagebottom').offset();
            if (offset == undefined)
                return;
            let height: number | undefined = $(window).height();
            let scrolltop: number | undefined = $(window).scrollTop();
            if (height === undefined || scrolltop === undefined)
                return;
            if ((offset.top - height <= scrolltop) && this.last_page <= this.numnews && !this.dcloadingnews) {
                this.dcloadingnews = true;
                if (!this.iscat)
                this.actucats = this.GetOptions().join(',');
                var url = "/api/v1.0/news/NewsList?page=" + this.last_page.toString() + "&pagesize=15&lancurrent=" + this.lancurrent + "&actucats=" + this.actucats;
                const response: AxiosResponse<NewsViewApiModel> = await axios.get<NewsViewApiModel>(url);
                if (response !== null && response.data !== null && response.data.newstab !== null) {
                    self.postnews = self.postnews.concat(response.data.newstab);
                    self.numnews = response.data.numtotalnews;
                    history.pushState(null, "", self.GetUrlNews(self.last_page - 1));
                    self.dcloadingnews = false;
                    self.last_page++;
                }
            }
        },

        async MoreNews() {
            let self = this;
            this.dcloadingnews = true;
            if (!this.iscat)
            this.actucats = this.GetOptions().join(',');
            var url = "/api/v1.0/news/NewsList?page=" + this.last_page.toString() + "&pagesize=15&lancurrent=" + this.lancurrent + "&actucats=" + this.actucats;
            const response: AxiosResponse<NewsViewApiModel> = await axios.get<NewsViewApiModel>(url);
            if (response !== null && response.data !== null && response.data.newstab !== null) {
                self.postnews = self.postnews.concat(response.data.newstab);
                self.numnews = response.data.numtotalnews;
                history.pushState(null, "", self.GetUrlNews(self.last_page - 1));
                self.dcloadingnews = false;
                self.last_page++;
            }
        },

        async ValidateBtn() {
            let options: string = this.GetOptions().join(',');
            if (options === "")
                options = "0";
            let self = this;
            this.iscat = false;
            let url: string = "/api/v1.0/news/Categories?page=1&cats=" + options;//urlnews.replace("%catlist%", options );
            const response: AxiosResponse<NewsViewApiModel> = await axios.get<NewsViewApiModel>(url);
            if (response !== null && response.data !== null && response.data.newstab !== null) {
                $("#firstrangenews").empty();
                self.postnews = response.data.newstab;
                self.numnews = response.data.numtotalnews;
                self.last_page = 1;
                history.pushState(null, "", self.GetUrlNews(self.last_page));
                self.last_page++;
                self.dcloadingnews = false;
            }
            return false;
        }
    }
});



export class NewsComponent {
    public Init(lancurrent: string, page: number, iscat:boolean, actucats: string, numnews: number) {
        glancurrent = lancurrent;
        gpage = page;
        giscat = iscat;
        gactucats = actucats;
        gnumnews = numnews;
        DCApp.mixins = [mixin];
        const app = Vue.createApp(DCApp);
        const pinia = createPinia();
        app.use(pinia);
        app.mount('#rootpage');
    } 
}
(<any>(window)).NewsComponent = function () { return new NewsComponent(); };